<template>
  <div>{{ users }}</div>
</template>

<script>
  import axios from "axios";
  export default {
    data: () => ({
      users: {

      }
    }),
    async mounted() {
      const response = await axios.post(process.env.VUE_APP_API_URL + '/users/login', {
        'email': 'example@mail.ru',
        'password': 'HolaAmigo'
      })
      this.users = response.data
    }
  }
</script>

<style scoped>

</style>
